import { Rocket, Smartphone, Brain, Cloud, BarChart3, Zap } from 'lucide-react';

export const serviceOverviews = [
  {
    slug: 'product-engineering',
    icon: Rocket,
    title: 'Product Engineering',
    description: 'Design and build scalable digital products and enterprise platforms that accelerate innovation, improve operational efficiency, and support long-term business growth.',
    accentColor: '#2563eb',
    accentGrad: 'linear-gradient(140deg, #1e40af 0%, #2563eb 60%, #3b82f6 100%)',
    image: '/service-images/product-engineering.png',
  },
  {
    slug: 'web-mobile-development',
    icon: Smartphone,
    title: 'Web & Mobile Development',
    description: 'Develop high-performance web and mobile applications with modern architectures, intuitive user experiences, and seamless cross-platform functionality.',
    accentColor: '#16a34a',
    accentGrad: 'linear-gradient(140deg, #14532d 0%, #16a34a 60%, #22c55e 100%)',
    image: '/service-images/web-mobile-development.png',
  },
  {
    slug: 'ai-automation',
    icon: Brain,
    title: 'AI & Intelligent Automation',
    description: 'Leverage AI, machine learning, and intelligent automation to streamline operations, improve decision-making, and create smarter customer experiences.',
    accentColor: '#e11d48',
    accentGrad: 'linear-gradient(140deg, #881337 0%, #e11d48 60%, #fb7185 100%)',
    image: '/service-images/ai-automation.png',
  },
  {
    slug: 'cloud-devops-infrastructure',
    icon: Cloud,
    title: 'Cloud, DevOps & Infrastructure',
    description: 'Build secure, resilient, and scalable cloud environments with automation-driven DevOps practices and optimized infrastructure management.',
    accentColor: '#0891b2',
    accentGrad: 'linear-gradient(140deg, #0e7490 0%, #0891b2 60%, #06b6d4 100%)',
    image: '/service-images/cloud-devops-infrastructure.png',
  },
  {
    slug: 'data-analytics',
    icon: BarChart3,
    title: 'Data & Analytics',
    description: 'Transform enterprise data into actionable insights through modern data engineering, analytics, visualization, and business intelligence solutions.',
    accentColor: '#9333ea',
    accentGrad: 'linear-gradient(140deg, #581c87 0%, #9333ea 60%, #a855f7 100%)',
    image: '/service-images/data-analytics.png',
  },
  {
    slug: 'emerging-technologies',
    icon: Zap,
    title: 'Emerging Technologies',
    description: 'Explore and implement next-generation technologies including Generative AI, IoT, Blockchain, AR/VR, and advanced automation to drive digital innovation.',
    accentColor: '#d97706',
    accentGrad: 'linear-gradient(140deg, #78350f 0%, #d97706 60%, #f59e0b 100%)',
    image: '/service-images/emerging-technologies.png',
  },
];
